import { Api } from "@/plugins/api"

export const rechercher = (recherche, codeService) => {
  return Api.post('repertoire/search', { ...recherche, codeService })
}

export const getDetails = (id) => {
  return Api.get('repertoire/details/' + id)
}
